import Colors from './Colors';
import Config from './Config';
import Locales from './Locales';
import Screens from './Screens';

export const MOVEMENT_EVENTS = ['move_event', 'knockback_event', 'death', 'unit_spawned'];

export { Colors, Config, Locales, Screens };

export const DISCORD_URL = 'https://discord.gg/ysgHx3ErwJ'; // 'https://discord.gg/dungeonteam'; //
export const BUG_REPORTS_DISCORD_URL =
  'https://discord.com/channels/1003381121792364604/1003381122647994471/1072461691587149834';
